import {TypeLien, TypeLienVisuel} from '../../../models/taches/gestion-taches.model';

export const TYPES_LIENS_VISUELS: TypeLienVisuel[] = [
  {
    typeId: TypeLien.personne,
    libelle: 'Personne',
    iconClass: 'user1'
  },
  {
    typeId: TypeLien.formateur,
    libelle: 'Formateur',
    iconClass: 'user-plus'
  }
    ,
    {
      typeId: TypeLien.entreprise,
      libelle: 'Entreprise',
      iconClass: 'command'
    },
    {
      typeId: TypeLien.session,
      libelle: 'Session',
      iconClass: 'file-text'
    },
    {
      typeId: TypeLien.personnel,
      libelle: 'Personnel',
      iconClass: 'groups'
    }
];
